import gql from 'graphql-tag';

const EXPORT_BACKPACK_REPORT = gql`
    query backpackReports ($sendToExport: String) {
        backpackReport (sendToExport: $sendToExport) {
        internalCode
        }
    }
`;

export default EXPORT_BACKPACK_REPORT;
